module.exports = __webpack_public_path__ + "media/images/mobile/survey-d3f62854d57e74e45927f0f8bd3e085e.png";